import { render } from "./AdminUserList.vue?vue&type=template&id=b27f6308&scoped=true&ts=true&lang=true"
import script from "./AdminUserList.vue?vue&type=script&lang=ts"
export * from "./AdminUserList.vue?vue&type=script&lang=ts"

import "./AdminUserList.vue?vue&type=style&index=0&id=b27f6308&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b27f6308"]])

export default __exports__